<template lang="pug">
section(v-bind:class="sectionClass")
	.section-content
		.has-text-centered
			.title.is-spaced.is-spaced-bottom {{ $t('home.title_partners') }}
		.columns.column-text-center.is-vcentered.columns-logos
			.column.is-narrow.has-text-centered
				img(src="/img/enel_logo_small.png" style="height: 56px;display:inline-block;")
			.column.is-narrow.has-text-centered
				img(src="/img/vodafone_business_small.png" style="height: 56px;display:inline-block;")
			.column.is-narrow.has-text-centered
				img(src="/img/fastweb_small.png" style="height: 60px;display:inline-block;")
		.columns.column-text-center.is-vcentered.columns-logos
			.column.is-narrow.has-text-centered
				img(src="/img/reale_mutua_small.png" style="height: 52px;display:inline-block;")
			.column.is-narrow.has-text-centered
				img(src="/img/findomestic_logo_small.png" style="height: 56px;display:inline-block;")
			.column.is-narrow.has-text-centered
				img(src="/img/jtwia_small.png" style="height: 56px;display:inline-block;")
			//-.column.is-narrow.has-text-centered
				img(src="/img/zucchetti_logo_small.png" style="height: 60px;display:inline-block;")
</template>

<script>
export default {
	name      : 'SectionFunctions',
	components: {},
	props: {
		num: Number
	},
	computed: {
		sectionClass() {
			return {
				'section'                : true,
				'border-bottom-section'  : false,
				'section-background-grey': this.num % 2 === 0
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.columns-logos
	min-height 8rem !important
	flex-wrap wrap

	.column
		padding 2rem 1.6rem

		@media screen and (max-width: 500px)
			padding 1.5rem 1rem
			width 100%
</style>
